import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _89bcb03c = () => import('../pages/ui.vue' /* webpackChunkName: "pages/ui" */).then(m => m.default || m)
const _068f09f6 = () => import('../pages/search.vue' /* webpackChunkName: "pages/search" */).then(m => m.default || m)
const _39c43b35 = () => import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */).then(m => m.default || m)
const _b8eafe38 = () => import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */).then(m => m.default || m)
const _23f421a1 = () => import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */).then(m => m.default || m)
const _f45bb402 = () => import('../pages/oferta.vue' /* webpackChunkName: "pages/oferta" */).then(m => m.default || m)
const _7f9dace2 = () => import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */).then(m => m.default || m)
const _e73076a6 = () => import('../pages/clients/index.vue' /* webpackChunkName: "pages/clients/index" */).then(m => m.default || m)
const _6a5c85db = () => import('../pages/company/docs.vue' /* webpackChunkName: "pages/company/docs" */).then(m => m.default || m)
const _56ab98f6 = () => import('../pages/products/transit.vue' /* webpackChunkName: "pages/products/transit" */).then(m => m.default || m)
const _12c1f9a4 = () => import('../pages/company/history.vue' /* webpackChunkName: "pages/company/history" */).then(m => m.default || m)
const _21c3c1ad = () => import('../pages/products/business.vue' /* webpackChunkName: "pages/products/business" */).then(m => m.default || m)
const _d6f9fe48 = () => import('../pages/products/special.vue' /* webpackChunkName: "pages/products/special" */).then(m => m.default || m)
const _47ff43fc = () => import('../pages/products/metro.vue' /* webpackChunkName: "pages/products/metro" */).then(m => m.default || m)
const _4b695002 = () => import('../pages/clients/suppliers.vue' /* webpackChunkName: "pages/clients/suppliers" */).then(m => m.default || m)
const _d2a06ba2 = () => import('../pages/company/people.vue' /* webpackChunkName: "pages/company/people" */).then(m => m.default || m)
const _67ffebe6 = () => import('../pages/news/creative.vue' /* webpackChunkName: "pages/news/creative" */).then(m => m.default || m)
const _04036800 = () => import('../pages/products/indoor.vue' /* webpackChunkName: "pages/products/indoor" */).then(m => m.default || m)
const _1989b4a0 = () => import('../pages/clients/partners.vue' /* webpackChunkName: "pages/clients/partners" */).then(m => m.default || m)
const _4535c041 = () => import('../pages/promo/sberbank-smb.vue' /* webpackChunkName: "pages/promo/sberbank-smb" */).then(m => m.default || m)
const _34a9bc4b = () => import('../pages/news/social.vue' /* webpackChunkName: "pages/news/social" */).then(m => m.default || m)
const _d3257104 = () => import('../pages/clients/cities.vue' /* webpackChunkName: "pages/clients/cities" */).then(m => m.default || m)
const _d1a47824 = () => import('../pages/products/airport.vue' /* webpackChunkName: "pages/products/airport" */).then(m => m.default || m)
const _169913a4 = () => import('../pages/news/world.vue' /* webpackChunkName: "pages/news/world" */).then(m => m.default || m)
const _854a6ea0 = () => import('../pages/clients/docs.vue' /* webpackChunkName: "pages/clients/docs" */).then(m => m.default || m)
const _299fb881 = () => import('../pages/clients/brands.vue' /* webpackChunkName: "pages/clients/brands" */).then(m => m.default || m)
const _07783b68 = () => import('../pages/online/_id.vue' /* webpackChunkName: "pages/online/_id" */).then(m => m.default || m)
const _294ffbe2 = () => import('../pages/products/metro_spb.vue' /* webpackChunkName: "pages/products/metro_spb" */).then(m => m.default || m)
const _4c515332 = () => import('../pages/news/_category/index.vue' /* webpackChunkName: "pages/news/_category/index" */).then(m => m.default || m)
const _75871c43 = () => import('../pages/products/_category/index.vue' /* webpackChunkName: "pages/products/_category/index" */).then(m => m.default || m)
const _31ad2381 = () => import('../pages/products/_category/other.vue' /* webpackChunkName: "pages/products/_category/other" */).then(m => m.default || m)
const _f5d92602 = () => import('../pages/news/_category/creative.vue' /* webpackChunkName: "pages/news/_category/creative" */).then(m => m.default || m)
const _8140341c = () => import('../pages/news/_category/world.vue' /* webpackChunkName: "pages/news/_category/world" */).then(m => m.default || m)
const _2486cd08 = () => import('../pages/products/_category/airport.vue' /* webpackChunkName: "pages/products/_category/airport" */).then(m => m.default || m)
const _b6859886 = () => import('../pages/news/_category/social.vue' /* webpackChunkName: "pages/news/_category/social" */).then(m => m.default || m)
const _19a5536b = () => import('../pages/products/_category/_id.vue' /* webpackChunkName: "pages/products/_category/_id" */).then(m => m.default || m)
const _2a1e7a1a = () => import('../pages/news/_category/_id.vue' /* webpackChunkName: "pages/news/_category/_id" */).then(m => m.default || m)
const _8163dcc4 = () => import('../pages/illegal_actions_message.vue' /* webpackChunkName: "pages/illegal_actions_message" */).then(m => m.default || m)
const _5d3ce418 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/ui",
			component: _89bcb03c,
			name: "ui"
		},
		{
			path: "/search",
			component: _068f09f6,
			name: "search"
		},
		{
			path: "/products",
			component: _39c43b35,
			name: "products"
		},
		{
			path: "/news",
			component: _b8eafe38,
			name: "news"
		},
		{
			path: "/contacts",
			component: _23f421a1,
			name: "contacts"
		},
		{
			path: "/oferta",
			component: _f45bb402,
			name: "oferta"
		},
		{
			path: "/company",
			component: _7f9dace2,
			name: "company"
		},
		{
			path: "/clients",
			component: _e73076a6,
			name: "clients"
		},
		{
			path: "/company/docs",
			component: _6a5c85db,
			name: "company-docs"
		},
		{
			path: "/products/transit",
			component: _56ab98f6,
			name: "products-transit"
		},
		{
			path: "/company/history",
			component: _12c1f9a4,
			name: "company-history"
		},
		{
			path: "/products/business",
			component: _21c3c1ad,
			name: "products-business"
		},
		{
			path: "/products/special",
			component: _d6f9fe48,
			name: "products-special"
		},
		{
			path: "/products/metro",
			component: _47ff43fc,
			name: "products-metro"
		},
		{
			path: "/clients/suppliers",
			component: _4b695002,
			name: "clients-suppliers"
		},
		{
			path: "/company/people",
			component: _d2a06ba2,
			name: "company-people"
		},
		{
			path: "/news/creative",
			component: _67ffebe6,
			name: "news-creative"
		},
		{
			path: "/products/indoor",
			component: _04036800,
			name: "products-indoor"
		},
		{
			path: "/clients/partners",
			component: _1989b4a0,
			name: "clients-partners"
		},
		{
			path: "/promo/sberbank-smb",
			component: _4535c041,
			name: "promo-sberbank-smb"
		},
		{
			path: "/news/social",
			component: _34a9bc4b,
			name: "news-social"
		},
		{
			path: "/clients/cities",
			component: _d3257104,
			name: "clients-cities"
		},
		{
			path: "/products/airport",
			component: _d1a47824,
			name: "products-airport"
		},
		{
			path: "/news/world",
			component: _169913a4,
			name: "news-world"
		},
		{
			path: "/clients/docs",
			component: _854a6ea0,
			name: "clients-docs"
		},
		{
			path: "/clients/brands",
			component: _299fb881,
			name: "clients-brands"
		},
		{
			path: "/online/:id?",
			component: _07783b68,
			name: "online-id"
		},
		{
			path: "/products/metro:spb",
			component: _294ffbe2,
			name: "products-metrospb"
		},
		{
			path: "/news/:category",
			component: _4c515332,
			name: "news-category"
		},
		{
			path: "/products/:category",
			component: _75871c43,
			name: "products-category"
		},
		{
			path: "/products/:category/other",
			component: _31ad2381,
			name: "products-category-other"
		},
		{
			path: "/news/:category/creative",
			component: _f5d92602,
			name: "news-category-creative"
		},
		{
			path: "/news/:category/world",
			component: _8140341c,
			name: "news-category-world"
		},
		{
			path: "/products/:category/airport",
			component: _2486cd08,
			name: "products-category-airport"
		},
		{
			path: "/news/:category/social",
			component: _b6859886,
			name: "news-category-social"
		},
		{
			path: "/products/:category/:id",
			component: _19a5536b,
			name: "products-category-id"
		},
		{
			path: "/news/:category/:id",
			component: _2a1e7a1a,
			name: "news-category-id"
		},
		{
			path: "/illegal:actions_message",
			component: _8163dcc4,
			name: "illegalactions_message"
		},
		{
			path: "/",
			component: _5d3ce418,
			name: "index"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js